import { createTheme } from '@mui/material/styles';

// Asureti Brand Colors
// Orange: rgb(245, 130, 32) - #F58220
// Blue: rgb(6, 143, 190) - #068FBE  
// Gray: rgb(119, 119, 122) - #77777A

const theme = createTheme({
  palette: {
    primary: {
      main: '#068FBE', // Asureti Blue
      light: '#4BB5D8',
      dark: '#045A7A',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#F58220', // Asureti Orange
      light: '#F8A357',
      dark: '#CC6B1A',
      contrastText: '#ffffff',
    },
    error: {
      main: '#d32f2f',
    },
    warning: {
      main: '#F58220', // Use brand orange for warnings
    },
    success: {
      main: '#2e7d32',
    },
    info: {
      main: '#068FBE', // Use brand blue for info
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
    text: {
      primary: '#77777A', // Asureti Gray for primary text
      secondary: '#9e9e9e',
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      color: '#77777A', // Asureti Gray
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      color: '#77777A',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      color: '#77777A',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: '#77777A',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
      color: '#77777A',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      color: '#77777A',
    },
  },
  shape: {
    borderRadius: 12, // Slightly more rounded for modern look
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
          padding: '8px 24px',
        },
        contained: {
          boxShadow: '0 2px 8px rgba(6, 143, 190, 0.25)',
          '&:hover': {
            boxShadow: '0 4px 16px rgba(6, 143, 190, 0.35)',
          },
        },
        containedSecondary: {
          boxShadow: '0 2px 8px rgba(245, 130, 32, 0.25)',
          '&:hover': {
            boxShadow: '0 4px 16px rgba(245, 130, 32, 0.35)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 12px rgba(119, 119, 122, 0.08)',
          borderRadius: 16,
          border: '1px solid rgba(119, 119, 122, 0.12)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(6, 143, 190, 0.15)',
          background: 'linear-gradient(135deg, #068FBE 0%, #4BB5D8 100%)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
        colorPrimary: {
          backgroundColor: '#068FBE',
          color: '#ffffff',
        },
        colorSecondary: {
          backgroundColor: '#F58220',
          color: '#ffffff',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#fafafa',
          '& .MuiTableCell-head': {
            fontWeight: 600,
            color: '#77777A',
          },
        },
      },
    },
  },
});

export default theme;
